import { ModuleRoute } from 'module-routes';

export enum ConfigurationPath {
  Rol = 'rol',
  Module = 'module',
  Menu = 'menu',
  Access = 'access',
  User = 'user',
  Profile = 'profile',
  Company = 'company',
  BranchOffice = 'branch-office',
  CashRegister = 'cash-register',
  SerialVoucher = 'serial-voucher',
  CategoryMovement = 'category-movement',
  Contacts = 'contacts',
}

export const ConfigModuleRoutes = new Map<ConfigurationPath, string>([
  [ConfigurationPath.Rol, `${ModuleRoute.Configuration}/${ConfigurationPath.Rol}`],
  [ConfigurationPath.Module, `${ModuleRoute.Configuration}/${ConfigurationPath.Module}`],
  [ConfigurationPath.Menu, `${ModuleRoute.Configuration}/${ConfigurationPath.Menu}`],
  [ConfigurationPath.Access, `${ModuleRoute.Configuration}/${ConfigurationPath.Access}`],
  [ConfigurationPath.User, `${ModuleRoute.Configuration}/${ConfigurationPath.User}`],
  [ConfigurationPath.Profile, `${ModuleRoute.Configuration}/${ConfigurationPath.Profile}`],
  [ConfigurationPath.Company, `${ModuleRoute.Configuration}/${ConfigurationPath.Company}`],
  [ConfigurationPath.BranchOffice, `${ModuleRoute.Configuration}/${ConfigurationPath.BranchOffice}`],
  [ConfigurationPath.CashRegister, `${ModuleRoute.Configuration}/${ConfigurationPath.CashRegister}`],
  [ConfigurationPath.SerialVoucher, `${ModuleRoute.Configuration}/${ConfigurationPath.SerialVoucher}`],
  [ConfigurationPath.CategoryMovement, `${ModuleRoute.Configuration}/${ConfigurationPath.CategoryMovement}`],
  [ConfigurationPath.Contacts, `${ModuleRoute.Configuration}/${ConfigurationPath.Contacts}`],
]);
